import photoshop from '../assets/photoshop 1.png'
import figma from '../assets/figma 1.png'
import xd from '../assets/xd 1.png'
import html from '../assets/html.png'
import css from '../assets/css.png'
import bootstrap from '../assets/bootstrap.png'
import tailwind from '../assets/tailwind.png'
import js from '../assets/js.png'
import typescript from '../assets/typescript.svg'
import redux from '../assets/redux.png'
import react from '../assets/react.png'
import next from '../assets/next-js.svg'
import mongodb from '../assets/mongodb-icon.svg'
export const MyTools = [
    {
        src: photoshop,
        name: "Photoshop",
    },
    {
        src: figma,
        name: "Figma",
    },
    {
        src: xd,
        name: "XD",
    },
    {
        src: html,
        name: "HTML",
    },
    {
        src: css,
        name: "CSS",
    },
    {
        src: bootstrap,
        name: "Bootstrap",
    },
    {
        src: tailwind,
        name: "Tailwind",
    },
    {
        src: js,
        name: "JavaScript",
    },
    {
        src: typescript,
        name: "TypeScript",
    },
    {
        src: redux,
        name: "React Redux",
    },
    {
        src: react,
        name: "React.js",
    },
    {
        src: next,
        name: "Next.js",
    },
    {
        src: mongodb,
        name: "MongoDB",
    },
]